import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoanProductShelfComponent } from './loan-product-shelf.component';

const routes: Routes = [{ path: '', component: LoanProductShelfComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoanProductShelfRoutingModule {}
